/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rap_Footer_CompanyInputs */

const en_rap_footer_company = /** @type {(inputs: Rap_Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Rap_Footer_CompanyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const rap_footer_company = /** @type {((inputs?: Rap_Footer_CompanyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rap_Footer_CompanyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rap_footer_company(inputs)
});
export { rap_footer_company as "rap.footer.company" }